import { createContext, useContext } from "react";
export const SettingsStoreContext = createContext(undefined);
export function useSettingsStore() {
    return useContext(SettingsStoreContext);
}
//# sourceMappingURL=settingsContext.js.map